const state = {
  list: [],
  selectedGlobalAllowListEntry: null,
};

const getters = {
  globalAllowList: (state) => state.list,
  selectedGlobalAllowListEntry: (state) => state.selectedGlobalAllowListEntry,
};

const actions = {
  async fetchGlobalAllowListEntry({ commit }, { allowId }) {
    const response = await this._vm.$http.get(`/restapi/allow/${allowId}`);

    commit("updateAllowListEntry", response.data);
    commit("setSelectedAllowListEntry", response.data);
  },

  async fetchGlobalAllowList({ commit }) {
    const response = await this._vm.$http.get(`/restapi/allow/`);

    commit("setGlobalAllowList", response.data);
  },

  async createGlobalAllowListEntry({ commit }, { body }) {
    const response = await this._vm.$http.post(`/restapi/allow`, body);

    commit("addAllowListEntry", response.data);
    return response.data;
  },

  async updateGlobalAllowListEntry({ commit }, { allowId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/allow/${allowId}`,
      body
    );

    const index = state.list.findIndex(
      (allowEntry) => allowEntry.id === response.data.id
    );

    if (index === -1) {
      commit("addAllowListEntry", response.data);
    } else {
      commit("updateAllowListEntry", {
        idx: index,
        allowListEntry: response.data,
      });
    }
  },

  async importGlobalAllowListEntries({ commit }, { body }) {
    const response = await this._vm.$http.post(`/restapi/allow/`, body);

    commit("importAllowListEntries", response.data);
  },

  async deleteGlobalAllowListEntry({ commit }, { allowId }) {
    const response = await this._vm.$http.delete(`/restapi/allow/${allowId}`);

    commit("deleteAllowListEntry", response.data);
  },
};

const mutations = {
  setGlobalAllowList: (state, data) => (state.list = data.data),
  setSelectedAllowListEntry: (state, data) =>
    (state.selectedAllowListEntry = data),
  addAllowListEntry: (state, data) => state.list.push(data),
  updateAllowListEntry: (state, data) =>
    (state.list[`${data.idx}`] = data.allowListEntry),
  importAllowListEntries: (state, data) =>
    (state.list = [...state.list, ...data]),
  deleteAllowListEntry: (state, data) =>
    (state.list = state.list.filter(
      (allowListEntry) => allowListEntry.id !== parseInt(data.id)
    )),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
